export default __webpack_public_path__ + "static/media/exploded-view_labels.e629b3d8.png";